import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

export const get_faq_categories_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/faqs/categories?${params}`
	);
	return response.data;
};

export const add_faq_category_api = async (body) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/faqs/categories`,
		body
	);
	return response.data;
};

export const update_faq_category_api = async (body) => {
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/faqs/categories`,
		body
	);
	return response.data;
};

export const delete_faq_category_api = async (id) => {
	const response = await authenticatedApi.delete(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/faqs/categories?id=${id}`
	);
	return response.data;
};

export const get_faqs_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/faqs?${params}`
	);
	return response.data;
};

export const add_faq_api = async (body) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/faqs`,
		body
	);
	return response.data;
};

export const update_faq_api = async (body) => {
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/faqs`,
		body
	);
	return response.data;
};

export const delete_faq_api = async (id) => {
	const response = await authenticatedApi.delete(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/faqs?id=${id}`
	);
	return response.data;
};
